// extracted by mini-css-extract-plugin
export var border = "SponsorDogPromoCardSquare-module--border--1ef31";
export var bordercontainer = "SponsorDogPromoCardSquare-module--bordercontainer--de901";
export var buttonwrapper = "SponsorDogPromoCardSquare-module--buttonwrapper--8eece";
export var image = "SponsorDogPromoCardSquare-module--image--8cdd8";
export var label = "SponsorDogPromoCardSquare-module--label--450b7";
export var labeltext = "SponsorDogPromoCardSquare-module--labeltext--5cba5";
export var leftheart = "SponsorDogPromoCardSquare-module--leftheart--79976";
export var rightheart = "SponsorDogPromoCardSquare-module--rightheart--ba69f";
export var sponsordogpromocontainer = "SponsorDogPromoCardSquare-module--sponsordogpromocontainer--091c1";
export var sponsordogpromocontainerdoglisting = "SponsorDogPromoCardSquare-module--sponsordogpromocontainerdoglisting--59af7";
export var text = "SponsorDogPromoCardSquare-module--text--24946";